import { Provider } from "react-redux";
import { SnackbarProvider } from "notistack";
import { ErrorBoundary } from "vino/core";
import { AppContextProvider } from "vino/context/AppContext";
import Layout from "./Layout";
import store from "./store";

const withAppProviders = (Component) => (props) => {
	const WrapperComponent = () => (
		<ErrorBoundary>
			<Provider store={store}>
				<SnackbarProvider>
					<AppContextProvider>
						<Layout>
							<Component {...props} />
						</Layout>
					</AppContextProvider>
				</SnackbarProvider>
			</Provider>
		</ErrorBoundary>
	);

	return WrapperComponent;
};

export default withAppProviders;
